import { palette } from '@livable/saas-react-components';
const MuiToggleButtonGroup = {
  styleOverrides: {
    root: {
      display: 'flex'
    },
    grouped: {
      '&:not(:first-of-type)': {
        borderLeft: "1px solid ".concat(palette.primary.main),
        '&:hover': {
          borderLeft: "1px solid ".concat(palette.primary.main)
        }
      }
    },
    groupedVertical: {
      '&:not(:first-of-type)': {
        borderTop: "1px solid ".concat(palette.primary.main)
      }
    }
  }
};
export default MuiToggleButtonGroup;